export default __webpack_public_path__ + "static/media/partner3.e1e99c09.jpg";